/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Currency} from '../models/Currency';
import type {Error} from '../models/Error';

export interface GetSupportedCurrencies$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedCurrenciesRequest = createAction<PayloadData<void>>('GET_SUPPORTED_CURRENCIES__GET_SUPPORTED_CURRENCIES__REQUEST');
export const getSupportedCurrenciesSuccess = createAction<PayloadData<Array<Currency>>>('GET_SUPPORTED_CURRENCIES__GET_SUPPORTED_CURRENCIES__SUCCESS');
export const getSupportedCurrenciesFailure = createAction<PayloadData<Error, void, true>>('GET_SUPPORTED_CURRENCIES__GET_SUPPORTED_CURRENCIES__FAILURE');

export const getSupportedCurrenciesActions = [
    getSupportedCurrenciesRequest,
    getSupportedCurrenciesSuccess,
    getSupportedCurrenciesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedCurrencies = (config?: GetSupportedCurrencies$Config) => {
    return {
        CALL_API: {
            types: getSupportedCurrenciesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/supported-currencies`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

